import ContentHeader from './ContentHeader'

export default ContentHeader



// WEBPACK FOOTER //
// ./src/components/ContentHeader/index.js